/**
 * フォント設定を一元管理する定数ファイル
 *
 * CSS: index.css の :root 変数を参照
 * TypeScript/JavaScript: このファイルの定数を使用
 */

/**
 * ベースフォントファミリー
 * 通常のテキスト表示に使用
 */
export const FONT_FAMILY_BASE = '"Noto Sans JP", "M PLUS Rounded 1c", "Roboto", "Open Sans", sans-serif';

/**
 * 等幅フォントファミリー
 * コード、ID、パスなどの表示に使用
 */
export const FONT_FAMILY_MONOSPACE = '"Courier New", Courier, monospace';

/**
 * CSS変数名（参考用）
 * CSSで使用する場合: font-family: var(--font-family-base);
 */
export const CSS_VAR_FONT_FAMILY_BASE = '--font-family-base';
export const CSS_VAR_FONT_FAMILY_MONOSPACE = '--font-family-monospace';
